import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Passthrough layout — /vendor/team children render here. */
export const Route = createFileRoute('/vendor/team')({
  component: () => <Outlet />,
});
